import { updateEmployeeModel } from "../../infrastructure/repository/employees-repository";

export default async function changeEmployeesBenefitPlan({
  companyId,
  employeeIds,
  benefitPlanId,
}: {
  companyId: string;
  employeeIds: string[];
  benefitPlanId: string;
}): Promise<void> {
  await updateEmployeeModel({ companyId, employeeIds, modelId: benefitPlanId });
}
